import { render, staticRenderFns } from "./AttachmentTypeCreate.vue?vue&type=template&id=b5c016de&"
import script from "./AttachmentTypeCreate.vue?vue&type=script&lang=js&"
export * from "./AttachmentTypeCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports